module.exports = __webpack_public_path__ + "static/img/21.1cf9f6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/21.png
// module id = F2Uo
// module chunks = 0